/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.industry.rpc.IndustryRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllAvailableIndustriesRpc = {
  serviceName: 'com.hubspot.blueprint.industry.rpc.IndustryRpc',
  rpcName: 'getAllAvailableIndustries',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC0j2kEYyl5y5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getIndustryRpc = {
  serviceName: 'com.hubspot.blueprint.industry.rpc.IndustryRpc',
  rpcName: 'getIndustry',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAtTTUD9IJbAZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertIndustryForPortalRpc = {
  serviceName: 'com.hubspot.blueprint.industry.rpc.IndustryRpc',
  rpcName: 'upsertIndustryForPortal',
  auth: 'app',
  fingerprint: 'sgM4n5Rvbh7TutYBVcGH-pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};